module.exports = __webpack_public_path__ + "047709f5f3e0cecac15da61732e2fbd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/plate-colorpicker/img/metal-color-hansgrohe-black-chrome-brushed-340.png
// module id = FI0L
// module chunks = 5